import { InfoCircleOutlined } from '@ant-design/icons';
import { Alert, Checkbox, Tooltip } from 'antd';

import Form from './Form';

interface TestsFormProps {
  tests: string[];
  requireTests?: boolean;
  namePrefix?: (string | number)[];
}

export interface TestsFormValues {
  testTypeList: string[];
}

const TestsForm = ({ tests, requireTests, namePrefix = [] }: TestsFormProps) => {
  const form = Form.useFormInstance();
  const testTypeList = Form.useWatch<string[] | undefined>([...namePrefix, 'testTypeList'], form);

  return (
    <>
      <Form.Item
        name={[...namePrefix, 'testTypeList']}
        rules={
          requireTests ? [{ min: 1, type: 'array', message: 'Selecione no mínimo um teste' }] : []
        }
      >
        <Checkbox.Group>
          <Form.Row>
            <Form.Col span={24}>
              <Checkbox value="OCP">Mapeamento Cultural</Checkbox>
              <Tooltip
                title={
                  <span>
                    Avalia o fit cultural com a empresa.
                    <br />
                    <strong>Duração média:</strong> 7 minutos
                  </span>
                }
              >
                <InfoCircleOutlined />
              </Tooltip>
            </Form.Col>
            {tests.map((test: string) => (
              <Form.Col key={test}>
                {test === 'SJT' && (
                  <>
                    <Checkbox value="SJT">Social</Checkbox>
                    <Tooltip
                      title={
                        <span>
                          Avalia habilidades interpessoais.
                          <br />
                          <strong>Duração média:</strong> 11 minutos
                        </span>
                      }
                    >
                      <InfoCircleOutlined />
                    </Tooltip>
                  </>
                )}
                {test === 'LOGIC' && (
                  <>
                    <Checkbox value="LOGIC">Mental</Checkbox>
                    <Tooltip
                      title={
                        <span>
                          Avalia a velocidade de aprendizagem e o potencial mental.
                          <br />
                          <strong>Duração média:</strong> 20 minutos
                        </span>
                      }
                    >
                      <InfoCircleOutlined />
                    </Tooltip>
                  </>
                )}
                {test === 'PROFILEMAP' && (
                  <>
                    <Checkbox value="PROFILEMAP">Perfil</Checkbox>
                    <Tooltip
                      title={
                        <span>
                          Avalia tendências de comportamento, com base no Big Five.
                          <br />
                          <strong>Duração média:</strong> 8 minutos
                        </span>
                      }
                    >
                      <InfoCircleOutlined />
                    </Tooltip>
                  </>
                )}
                {test === 'MOTIVATIONAL' && (
                  <>
                    <Checkbox value="MOTIVATIONAL">Motivacional</Checkbox>
                    <Tooltip
                      title={
                        <span>
                          Avalia postura motivacional frente a dificuldades e incertezas.
                          <br />
                          <strong>Duração média:</strong> 13 minutos
                        </span>
                      }
                    >
                      <InfoCircleOutlined />
                    </Tooltip>
                  </>
                )}
                {test === 'INTERESTS' && (
                  <>
                    <Checkbox value="INTERESTS">Interesses profissionais</Checkbox>
                    <Tooltip
                      title={
                        <span>
                          Avalia as atividades de maior interesse do candidato.
                          <br />
                          <strong>Duração média:</strong> 12 minutos
                        </span>
                      }
                    >
                      <InfoCircleOutlined />
                    </Tooltip>
                  </>
                )}
                {test === 'OPERATIONAL' && (
                  <>
                    <Checkbox value="OPERATIONAL">Raciocínio Simplificado</Checkbox>
                    <Tooltip
                      title={
                        <span>
                          Avalia a habilidade de resolução de problemas lógicos e análise numérica.
                          <br />
                          <strong>Duração média:</strong> 9 minutos
                        </span>
                      }
                    >
                      <InfoCircleOutlined />
                    </Tooltip>
                  </>
                )}
              </Form.Col>
            ))}
          </Form.Row>
        </Checkbox.Group>
      </Form.Item>
      {(!requireTests && testTypeList?.length === 0) ||
        (testTypeList?.length !== tests.length + 1 /** OCP - Mapeamento cultural */ && (
          <>
            <Alert
              message="Lembre-se: para o cálculo do Match com a posição, o candidato precisa responder todos os testes acima. Se o candidato já respondeu algum teste, não se preocupe, ele será avisado ao clicar no link."
              type="warning"
              showIcon
            />
            <br />
          </>
        ))}
    </>
  );
};

export default TestsForm;
